import { ISemSimplifiedLpXP } from "@faire/web-api/indigofair/seo/ISemSimplifiedLpXP";
import { ENABLE_SEM_SIMPLIFIED_LP_TEST_101124 } from "@faire/web-api/indigofair/settings/ENABLE_SEM_SIMPLIFIED_LP_TEST_101124";
import { useSearchParams } from "next/navigation";
import { useMemo } from "react";

import { useIsLoggedOutDiscoverPage } from "../views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";

import { useSetting } from "./__internal__/useSetting";
import { getIsSettingSemSimplifiedLpEnabled } from "./getIsSettingSemSimplifiedLpEnabled";

/**
 * @name useIsSettingSemSimplifiedLpEnabled
 * @description Determines if user is a paid user
 * and if the SemSimplifiedLp is enabled.
 *
 * @note medium=cpc is the query parameter that is
 * used to determine if the user is a paid user.
 * We also need to determine if the user is on the discover
 * search page.
 */
export const useIsSettingSemSimplifiedLpEnabled = (): boolean => {
  const isLoggedOutDiscoverPage = useIsLoggedOutDiscoverPage();
  const settingVariant = useSetting(
    ENABLE_SEM_SIMPLIFIED_LP_TEST_101124,
    ISemSimplifiedLpXP.Bucket.CONTROL
  );
  const searchParams = useSearchParams();

  return useMemo(
    () =>
      getIsSettingSemSimplifiedLpEnabled({
        settingVariant,
        searchParams,
        isLoggedOutDiscoverPage,
      }),
    [isLoggedOutDiscoverPage, searchParams, settingVariant]
  );
};
